import React from 'react';

const SAME_SAME_ANYDAY_URL = 'https://anyday.com.au/samesame-venue-page';

class Redirect extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			countdown: 3,
		};
	}

	componentDidMount() {
		this.interval = setInterval(() => {
			this.setState(prevState => ({
				countdown: prevState.countdown > 0 ? prevState.countdown - 1 : 0,
			}));
		}, 1000);

		this.timeout = setTimeout(() => {
			window.location.replace(SAME_SAME_ANYDAY_URL);
		}, 3000);
	}

	componentWillUnmount() {
		clearInterval(this.interval);
		clearTimeout(this.timeout);
	}

	render() {
		return (
			<div className="body-container">
				<div
					className="redirect-main-content-container"
				>
					<a
						href={SAME_SAME_ANYDAY_URL}
						aria-label="Go to Anyday website"
						style={{
							display: 'inline-flex',
							width: '100%',
							maxWidth: 400,
						}}
					>
						<img src="/imgs/anyday_logo.svg" alt="" style={{ width: '100%' }} />
					</a>

					<div className="redirect-main-content-text" style={{ textAlign: 'center' }}>
                    SAME SAME has moved to our new website.<br />In {this.state.countdown} seconds, you will be automatically redirected to <a href={SAME_SAME_ANYDAY_URL} aria-label="Go to Anyday website" style={{ textDecoration: 'underline' }}>anyday.com.au</a>
					</div>
				</div>
			</div>

		);
	}
}

export default Redirect;



// WEBPACK FOOTER //
// ./src/Theme/Redirect.jsx